<template>
  <feather-icon icon="PrinterIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="getBookLists()"/>
</template>

<script>
  import jsPDF from "jspdf";
  import 'jspdf-autotable'

  const fs = require('fs');
  import {font} from "./assets/THSarabunNew-normal";
  import {font_bold} from "./assets/THSarabunNew-bold";
  import moment from "moment";
  import {formatNumber2Digit, formatNumber} from "./assets/utils";
  export default {
    props: ['billConfig', 'area', 'org', 'status', 'textTitle'],
    components: {
      jsPDF,
    },
    name: "RealUserReport",
    data() {
      return {
        district: 'องค์การบริหารส่วนตำบลจำปาโมง',
        address: 'ต.จำปาโมง อ.บ้านผือ จ.อุดรธานี้',
        month: 'ตุลาคม-61',
        id_bill: '(62-001)',
        date: '20/01/2020',
      }
    },
    methods: {
      currentThaiDate() {
        const date = moment().format('DD/MM/YYYY');
        const dateSplit = date.split('/');
        const year = parseInt(dateSplit[2]) + 543;
        return dateSplit[0] + '/' + dateSplit[1] + '/' + year;
      },
      groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        }, {});
      },
      warningDialog() {
        this.$vs.dialog({
          type: 'alert',
          color: 'warning',
          title: `คำเตือน`,
          text: 'ไม่มีรายชื่อในรายงานสรุป' + this.textTitle,
          acceptText: 'ปิด'
        })
      },
      async getBookLists() {
        this.$vs.loading();
        let payload = {};
        payload.B01 = this.billConfig.label;
        await this.$store.dispatch("bookLists/fetchDebtDataListItems", payload).then((res) => {
          if (res.status === 200 && res.data.length !== 0) {
            const booklists = res.data;
            this.generatePDF(booklists, this.billConfig.label);
            this.$vs.loading.close();
          } else {
            this.warningDialog();
            this.$vs.loading.close();
          }
        }).catch((error) => {
          this.warningDialog();
          this.$vs.loading.close();
        });
      },
      generatePDF(bookLists, billConfig) {
        const doc = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: [279.4, 210]
        });
        const status = this.status;
        const org = this.org;
        const title = 'บัญชีสรุป' + this.textTitle
        const date = this.currentThaiDate()
        let array = [];
        bookLists = bookLists.filter(function (item) {
          if (status === '') {
            return item
          } else {
            return item.B10 === status;
          }
        });
        let areaList = [];
        let BA14Sum = 0;
        let BA15Sum = 0;
        let allSum = 0;
        let sumBA1415 = 0;
        let group = this.groupBy(bookLists, 'member_area');
        Object.keys(group).forEach(function (key) {
          let B21 = 0;
          let sumBA14 = 0.0;
          let sumBA15 = 0.0;
          let allSum = 0;
          let allPaidSum = 0;
          let diffPaid;
          group[key].forEach(function (key) {
            B21 = B21 + parseInt(key['B21'])
            sumBA14 = sumBA14 + parseFloat(key['BA14'])
            sumBA15 = sumBA15 + parseFloat(key['BA15'])
            allSum = sumBA14 + sumBA15
            if (key['B10'] === '1') {
              allPaidSum = sumBA14 + sumBA15
            }
          });
          diffPaid = allSum - allPaidSum
          areaList.push({
            member_area: key,
            BA14: sumBA14,
            BA15: sumBA15,
            sum: allSum,
          })
        })
        areaList.sort((a, b) => parseInt(a['member_area']) - parseInt(b['member_area']));
        areaList.forEach(function (item) {
          array.push([item.member_area,
            formatNumber2Digit(item.BA14),
            formatNumber2Digit(item.BA15),
            formatNumber(item.sum)])
          BA14Sum += parseFloat(item.BA14);
          BA15Sum += parseFloat(item.BA15);
          allSum += parseFloat(item.sum);
          sumBA1415 = BA14Sum + BA15Sum;
        })
        array.push([
          'รวมทั้งสิ้น',
          formatNumber2Digit(BA14Sum),
          formatNumber2Digit(BA15Sum),
          formatNumber(allSum),
        ]);
        array.push([
          'ค่ากำจัดขยะฯ+ค่าขยะ',
          '',
          '',
          formatNumber(sumBA1415),
        ]);
        var totalPagesExp = '{total_pages_count_string}';
        doc.addFileToVFS('THSarabunNew-normal.ttf', font);
        doc.addFileToVFS('THSarabunNew-bold.ttf', font_bold);
        doc.addFont('THSarabunNew-normal.ttf', 'THSarabunNew', 'normal');
        doc.addFont('THSarabunNew-bold.ttf', 'THSarabunNew', 'bold');
        doc.autoTable({
          showHead: 'everyPage',
          showFoot: 'everyPage',
          styles: {font: 'THSarabunNew', textColor: 0, halign: 'right', fontSize: 14},
          headStyles: {fillColor: [255, 255, 255], textColor: 0, halign: 'right'},
          margin: {left: 8, top: 35, right: 8},
          theme: 'plain',
          head: [
            ['เขต', 'ค่ากำจัดขยะฯ', 'ค่าขยะ', 'รวม' + this.textTitle]
          ],
          body: array,
          didDrawPage: function (data) {
            // Header
            doc.setFont('THSarabunNew', 'bold');
            doc.setFontSize(16);
            doc.text(org.Org01, doc.internal.pageSize.getWidth() / 2, 10, {align: 'center'});
            doc.text(org.Org03, doc.internal.pageSize.getWidth() / 2, 18, {align: 'center'});
            doc.setFontSize(14);
            doc.text(title + ' ' + billConfig, doc.internal.pageSize.getWidth() / 2, 25, {align: 'center'});
            doc.setFont('THSarabunNew', 'normal');
          },
        });
        const pages = doc.internal.getNumberOfPages();
        const pageSize = doc.internal.pageSize;
        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        for (let j = 1; j < pages + 1 ; j++) {
          doc.setPage(j);
          doc.addFileToVFS('THSarabunNew-normal.ttf', font);
          doc.addFileToVFS('THSarabunNew-bold.ttf', font_bold);
          doc.addFont('THSarabunNew-normal.ttf', 'THSarabunNew', 'normal');
          doc.addFont('THSarabunNew-bold.ttf', 'THSarabunNew', 'bold');
          doc.setFont('THSarabunNew', 'normal');
          doc.setFontSize(12);
          doc.text('วันที่พิมพ์ ' + date, 10, pageHeight - 8,)
          doc.text(`หน้าที่พิมพ์ ${j} of ${pages}`, 180, pageHeight - 8, {align: 'center'})
        }
        doc.save(`สรุปยอด` + this.textTitle + `-` + moment().format('DD-MM-YYYY') + '.pdf');
      }
    }
  }
</script>
